var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000305176,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.7082 13.625C21.7832 10.6 18.9665 8.85837 15.9998 8.85837C14.5165 8.85837 13.0748 9.2917 11.7582 10.1C10.4415 10.9167 9.25817 12.1084 8.2915 13.625C7.45817 14.9334 7.45817 17.0584 8.2915 18.3667C10.2165 21.4 13.0332 23.1334 15.9998 23.1334C17.4832 23.1334 18.9248 22.7 20.2415 21.8917C21.5582 21.075 22.7415 19.8834 23.7082 18.3667C24.5415 17.0667 24.5415 14.9334 23.7082 13.625ZM15.9998 19.3667C14.1332 19.3667 12.6332 17.8584 12.6332 16C12.6332 14.1417 14.1332 12.6334 15.9998 12.6334C17.8665 12.6334 19.3665 14.1417 19.3665 16C19.3665 17.8584 17.8665 19.3667 15.9998 19.3667Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.6167C14.6917 13.6167 13.625 14.6834 13.625 16C13.625 17.3084 14.6917 18.375 16 18.375C17.3083 18.375 18.3833 17.3084 18.3833 16C18.3833 14.6917 17.3083 13.6167 16 13.6167Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.5b427753830b45a06a4061aaad50a8a0.svg";
export { ForwardRef as ReactComponent };